import appModule from './app.module'
import { resolveAdminAppTransition } from './adminAppGuard'
import { resolveServiceTicketsTransition } from './serviceTicketsGuard'

appModule.run(['$rootScope', '$state', '$stateParams', 'ENV', 'version', '$transitions', 'auth', '$timeout', "$q", "userApi",
    function($rootScope, $state, $stateParams, ENV, version, $transitions, auth, $timeout,$q, userApi,) {
        var currentFormDirty = false;

        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.apiEndpoint = ENV.apiEndpoint;
        $rootScope.googleApiKey = ENV.googleApiKey;
        $rootScope.env = ENV.name;
        $rootScope.currentUser = null;

        $rootScope.isTouchDevice = () => {
            return navigator.maxTouchPoints > 0
        }

        $q(() => {
            userApi.getCurrentUser()
        })

        // used to prompt user confirmation on switching to another page while current form has pending changes
        $rootScope.$on('$locationChangeStart', function(event) {
            if (currentFormDirty) {
                if (confirm('There are unsaved changes. Are you sure you want to leave this page?')) {
                    currentFormDirty = false;
                }
                else {
                    event.preventDefault();
                }
            }
        });

        console.log(`${ENV.name} Version: ${version}`)

        $(document).ready(function() {
            $("body").css("display", "block");
        });

        $transitions.onStart({}, function(trans) {
            const protectedRoute = trans.to().protected
            if (protectedRoute && !auth.isAuthenticated()) {
                // User isn't authenticated. Redirect to a new Target State
                $rootScope.loginReturnState = trans.targetState()
                return trans.router.stateService.target('authentication.login');
            }

            const adminAppTransition = resolveAdminAppTransition(trans, () => userApi.getCurrentUser())
            if (adminAppTransition !== undefined) {
                return adminAppTransition
            }

            return resolveServiceTicketsTransition(trans, () => userApi.getCurrentUser())
        });

        $transitions.onSuccess({}, function(trans) {
            $timeout(function() {
                initSidebar(trans)
                initFormReload()
            }, 300)

        });

        function initSidebar(trans) {
            $('#app-sidebar li.active').removeClass("active");

            var path = trans.to().baseUrl
            var item = $('#app-sidebar a[href="#!' + path + '"]')
            if (item) {
                item.parent().addClass("active");
            }
        }

        $rootScope.$on("form-dirtied", () => {
            currentFormDirty = true;
        })

        $rootScope.$on("form-cleaned", () => {
            currentFormDirty = false
        })

        function initFormReload() {
            var form = $("form.reload-protected")
            if (form.length > 0) {
                form.on("change", "input, select, textarea", function() {
                    currentFormDirty = true;
                });

                $(".form-save, .form-cancel").on("click", function() {
                    currentFormDirty = false;
                });
            }
        }
    }
])
